import { render, staticRenderFns } from "./ClientGroupContainer.vue?vue&type=template&id=0b979750&scoped=true&"
import script from "./ClientGroupContainer.vue?vue&type=script&lang=js&"
export * from "./ClientGroupContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b979750",
  null
  
)

export default component.exports